import axios from "axios";
import React, {useState} from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";
import sledgehammerImg from "../assets/sledgehammer-img.png";
import { useAuth } from "../context/AuthContext";
import { useSnackbar } from "notistack";
import { SLEDGEHAMMER_BASE_API } from "../config";

const Login = () => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { login } = useAuth();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const baseUrl = SLEDGEHAMMER_BASE_API;

    const handleLogin = async (e) => {
        e.preventDefault();
        if(!email || !password)
            enqueueSnackbar('Please enter both email and password', { variant: 'error' });

        try {
            const res = await axios.post(`${baseUrl}/auth/login`, {
                email,
                password
            });
            console.log('status', res.data.success);
            if(res.data.success) {
                const token = res.data.access_token;
                login(token);
                navigate("/dashboard");
                enqueueSnackbar('Login successful!', { variant: 'success' });
            } else {
                enqueueSnackbar('Invalid email or password', { variant: 'error' });
            }
            
        } catch (error) {
            enqueueSnackbar('Network error. Please check your connection.', { variant: 'error' });
        }
      };

    return (
    <>
        <div className="login">
            <div className="container">
                <form>
                <img src={sledgehammerImg} alt="login" style={{ width: 400, aspectRatio: "1 / 1", objectFit: "contain" }}   />
                </form>
                <form className="myform" onSubmit={handleLogin}>
                <h3>
                    Hi <em>👋</em>, Welcome Back!
                </h3>
                <div>
                    <input type="email" placeholder="Email Address" required value={email} onChange={(e) => setEmail(e.target.value)} />
                    <div className="mydiv">
                    <input type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className="second-div">
                    <button type="submit">Login</button>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </>
    );
};

export default Login;
